<template>
  <main class="l-main p-error">
    <div class="l-block">
      <div v-if="auth.isAuthenticated" class="p-error-nav">
        <Button variant="light" radius @click="logout">
          ログアウト
        </Button>
      </div>
      <div class="l-block__header">
        <router-link :to="{ name: 'login' }">
          <img src="@/assets/img/logo.svg" :alt="$constants.siteName" />
        </router-link>
      </div>
      <div class="l-block__content p-error__content">
        <h1 class="p-error__title">アカウントが有効ではありません</h1>
        <p>
          アカウントが有効ではないため、SEARCH WRITEをご利用いただけません。
          <br />ご利用したい場合、もしくは再開したい場合はカスタマーサポート(<a
            :href="'mailto:' + $constants.customerSupportEmail"
            >{{ $constants.customerSupportEmail }}</a
          >)までお問い合わせください。
        </p>
      </div>
    </div>
  </main>
</template>

<script>
import Button from '@/components/Button';

export default {
  components: {
    Button
  },
  computed: {
    isAuthenticated() {
      return this.auth.isAuthenticated;
    },
    hasAccountError() {
      return this.$store.state.user.status.isDisabled;
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'login' });
    }
    if (!this.hasAccountError) {
      this.$router.push({ name: 'projects' });
    }
  },
  methods: {
    logout() {
      this.auth.logout();
    }
  }
};
</script>
